import * as Styles from '../styles';
import {  useState } from 'react';
import { CommonDropdown } from "../../common/CommonSelector";
import {SettingsFieldTabs} from './SettingsFieldTabs';
import {BUTTON_VARIANTS,} from 'cdk-radial'
import { useTranslation } from "react-i18next";
import { useAnalytics } from '../../../v2/third-party-integration/amplitude';
import { AMPLITUDE_EVENTS } from '../../../constants';

export default function SettingDialog({
  widget,
  onSave,
  isOpen,
  onClose,
}: any) {
  const { thresholdFields } = widget;
  const {t} = useTranslation();
  const [isSaveDisabled, setSaveDisabled] = useState(false);
  const { trackEvent } = useAnalytics();

  const options = [
    { value: 'area', label: 'Area Chart' },
    { value: 'bar', label: 'Bar Chart' },
    { value: 'funnel', label: 'Funnel Chart' },
    { value: 'grid', label: 'Grid View' },
    { value: 'line', label: 'Line Chart' },
    { value: 'metrics', label: 'Metrics View' },
    { value: 'pie', label: 'Pie Chart' },
    { value: 'stacked-bar', label: 'Stacked Bar Chart' },
    { value: 'table', label: 'Table View' },
  ].filter((option) => widget.availableViews.includes(option.value));


  const getInitialSettings = () => {
    const existingFields = widget.fields || [];
    const fields = thresholdFields?.map((item: any) => {
      const existingField = existingFields.find(
        (f: any) => f.name === item.name
      );
      return (
        existingField || {
          name: item.name,
          threshold: {
            type: 'absolute',
            conditions: [],
          },
        }
      );
    });

    return {
      id: widget.id,
      dashboardId: widget.dashboardId,
      view: widget.view,
      fields,
    };
  };

  const [settings, setSettings] = useState(getInitialSettings());
  const defaultView =
    options.find((o) => o.value === widget.view) ||
    options.find((o) => o.value === widget.defaultView) ||
    options[0] as any;

  const [selectedView, setSelectedView] = useState(defaultView);

  const resetDialogStateAndClose = () => {
    setSettings(getInitialSettings());
    setSelectedView(defaultView);
    setSaveDisabled(false);
    onClose();
  };

  const updateView = (selectedViewOption: any) => {
    const view = selectedViewOption.value;
    setSelectedView(selectedViewOption)
    setSettings((prev: any) => ({ ...prev, view }));
  };

  const handleSave = () => {
      trackEvent(AMPLITUDE_EVENTS.SAVE_DASHBOARD_SETTINGS, {
      'Item': widget.title,
    });
    onSave(settings);
  };

  const handleUpdateFromTabs = (updatedFields: any) => {
    setSettings((prev) => ({
      ...prev,
      fields: updatedFields
    }));
  };

  return (
    <Styles.WidgetSettingDialog
      id="learn-more-dialog"
      title="Settings"
      isOpen={isOpen}
      onClose={resetDialogStateAndClose}
      disableOverlayClicked={false}
      buttonsProps={[
        {
          id: 'dialog-7-action-1',
          onClick: resetDialogStateAndClose,
          text: t('dashboard.settings.cancel'),
          variant: BUTTON_VARIANTS.TEXT,
        },
        {
          id: 'dialog-7-action-2',
          onClick: handleSave,
          isDisabled:isSaveDisabled,
          text: t('dashboard.settings.save'),
          variant: BUTTON_VARIANTS.PRIMARY,
        },
      ]}
    >
      <div style={{
              padding: '10px',
              width: 'auto',
              height:'650px'
            }}>


          <div style={{marginTop:'10px'}}>
          {widget.defaultView !== 'metrics' && (
            <div>
              <CommonDropdown
                    options={options as any}
                    name="view"
                    label={t('dashboard.settings.view') as any} 
                    placeholder=""
                    selectedOption={selectedView}
                    onSelect={updateView} />
            </div>
          )}

          <div style={{marginTop:'10px'}}>
            <SettingsFieldTabs settings={settings} widget={widget} onChange={handleUpdateFromTabs}></SettingsFieldTabs>
          </div>
        </div>

      </div>
    </Styles.WidgetSettingDialog>
  );
}
